module.exports = __webpack_public_path__ + "statics/img/TargetAudience-2.4e567fd9.png";